module.exports = __webpack_public_path__ + "static/media/edsiderlogo.b77d6133.png";